import React from 'react';
import {graphql} from 'gatsby';
import get from 'lodash/get';

import TEMPLATE_TYPE from '@/constants/templateType';

import BlogPostTemplate from '@/templates/Blog/templates/BlogPost/BlogPost';
import BlogListTemplate from '@/templates/Blog/templates/BlogList/BlogList';

const MAP_LOCALE = {
  "pl": "pl",
  "en-GB": "uk",
  "uk": "ua",
  "de": "de",
  "cs": "cz",
  "ro": "ro",
  "hu": "hu",
  "sk": "sk",
  "bg": "bg",
  "fr": "fr",
  "it": "it",
  "es": "es",
  "nl": "nl",
  "sv": "se",
  "pt": "pt",
  "da": "dk",
  "fi": "fi"  
};

const BlogList = props => {
  const category = get(props, 'data.strapiBlogList');
  const postsModel = get(props, 'data.allStrapiBlogPost.edges');

  const {pageContext} = props;

  const hrefLang = [];

  const addHrefLang = (locale, categorySlug) => {
    if (MAP_LOCALE[locale]) {
      const href = `https://natu.care/${MAP_LOCALE[locale]}/${categorySlug}`;
    
      hrefLang.push({ locale, href });
    
      if (locale === 'pl') {
        hrefLang.push({ locale: 'x-default', href });
      }
    }
  };
  
  addHrefLang(category.locale, category.slug);
  
  category?.localizations?.data?.forEach(({ attributes: { locale, slug } }) => {
    addHrefLang(locale, slug);
  });

  const blogListProps = {
    pageContext,
    data: category,
    postsModel,
    hrefLang: hrefLang.sort((a, b) => (a.locale === 'x-default' ? -1 : b.locale === 'x-default' ? 1 : 0))
  };

  switch (category.templateType) {
    case TEMPLATE_TYPE.BLOG_POST:
      return <BlogPostTemplate {...blogListProps} />;

    default:
      return <BlogListTemplate {...blogListProps} />;
  }
};

export default BlogList;

export const pageQuery = graphql`
  fragment authorField on STRAPI_AUTHOR {
    role
    firstName
    lastName
    muckrack
    linkedin
    slug
    hasAuthorPage
    description 
    imageSmall {
      url
    }
    imageLarge {
      url
    }
    email
    honorificSuffix
    honorificSuffixDescription
    knowsAbout {
      name
    }
    hasOccupation
  }  

  query BlogListBySlug(
    $slug: String!,
    $locale: String! = "pl"
  ) {
    strapiBlogList(slug: { eq: $slug }, locale: {eq: $locale}) 
    {
      localizations {
        data {
          attributes {
            slug
            locale
          }
        }
      }       
      templateType
      locale
      strapi_id
      slug
      shortHeading
      heading
      shortContent
      options {
        strapi_json_value
      }
      seo {
        title
        description
      }
      featuredImage {
        url
      }
      author  {
        ...authorField
      }
      reviewedBy {
        ...authorField
      }
      editedBy {
        ...authorField
      }
      factChecker {
        ...authorField
      }
      createdAtCustom(locale: $locale, formatString: "DD MMMM, YYYY")
      createdAtDatetime: createdAtCustom(locale: $locale, formatString: "YYYY-MM-DD")
      updatedAtCustom(locale: $locale, formatString: "DD MMMM, YYYY")
      updatedAtDatetime: updatedAtCustom(locale: $locale, formatString: "YYYY-MM-DD")
      editedOn(locale: $locale, formatString: "DD MMMM, YYYY")
      editedOnDatetime: editedOn(locale: $locale, formatString: "YYYY-MM-DD")
      reviewedOn(locale: $locale, formatString: "DD MMMM, YYYY")
      reviewedOnDatetime: reviewedOn(locale: $locale, formatString: "YYYY-MM-DD")
      factCheckedOn(locale: $locale, formatString: "DD MMMM, YYYY")
      factCheckedOnDatetime: factCheckedOn(locale: $locale, formatString: "YYYY-MM-DD")
      rawDate: createdAtCustom
      metaPublishedTime: createdAtCustom(formatString: "YYYY-MM-DDTHH:mm:ssZ")
      metaUpdatedTime: updatedAtCustom(formatString: "YYYY-MM-DDTHH:mm:ssZ")
  }

      
    allStrapiBlogPost(
      filter: {options: {strapi_json_value: {nin: "hideInListing"}}, category: {slug: { eq: $slug }, locale: {eq: $locale}}}
      sort: {createdAtCustom: DESC}
    ) {
      edges {
        node {     
          locale
          slug
          shortHeading
          heading
          shortContent
          seo {
            title
          }
          thumbnailImage {
            url
          }
          content {
            data {
              content
            }
          }
          category {
            slug
            heading
            shortHeading
          }
          createdAtFullDate: createdAtCustom(locale: $locale, formatString: "DD MMMM, YYYY")
          createdAtShortDate: createdAtCustom(locale: $locale, formatString: "MMM DD")
          dateFormat: createdAtCustom(locale: $locale, formatString: "YYYY-MM-DD")
        }
      }
    }
  }
`;
